import { useEffect, useState } from 'react';
import { MIN_REJECT_REASON_LENGTH, isValidRejectReason } from '@eombor/contracts';
import { Button, Dialog, Input, cn } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';

export interface RejectDialogProps {
  open: boolean;
  onClose: () => void;
  /** Sabab BO'SH JOYLARSIZ keladi — server ham aynan shu matnni ko'radi. */
  onConfirm: (reason: string) => void;
  pending?: boolean;
  /** Serverdan kelgan xato — odam uchun yozilgan matn. */
  error?: string | null;
}

/**
 * Rad etish oynasi.
 *
 * Sabab MAJBURIY va u shunchaki forma qoidasi emas: rad etilgan talabnoma
 * hujjatga tushadi va uni o'qigan odam nima qilish kerakligini bilishi kerak.
 * Eng qisqa uzunlik shartnomadan olinadi (`MIN_REJECT_REASON_LENGTH`) — server
 * ham AYNAN shu chegara bilan tekshiradi, ya'ni ekranda ruxsat etilgan sabab
 * u yerda kutilmaganda rad etilmaydi.
 */
export const RejectDialog = ({
  open,
  onClose,
  onConfirm,
  pending = false,
  error = null,
}: RejectDialogProps) => {
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);

  // Oyna har ochilganda toza boshlanadi — oldingi urinishning matni qolmaydi.
  useEffect(() => {
    if (!open) return;
    setReason('');
    setTouched(false);
  }, [open]);

  const valid = isValidRejectReason(reason);
  const tooShort = touched && !valid;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('requisition.rejectTitle')}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            {t('requisition.cancel')}
          </Button>
          <Button
            variant="danger"
            loading={pending}
            disabled={!valid}
            onClick={() => onConfirm(reason.trim())}
          >
            {t('requisition.action.REJECTED')}
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <p className="text-sm text-text-muted">{t('requisition.rejectHint')}</p>

        {error === null ? null : (
          <p
            role="alert"
            className={cn(
              'rounded-[var(--radius-sm)] border border-danger/25 bg-danger-soft',
              'px-3 py-2 text-sm text-danger',
            )}
          >
            {error}
          </p>
        )}

        <Input
          label={t('requisition.rejectLabel')}
          autoComplete="off"
          maxLength={500}
          value={reason}
          onChange={(event) => {
            setReason(event.target.value);
            setTouched(true);
          }}
          error={tooShort ? t('requisition.rejectTooShort', { min: MIN_REJECT_REASON_LENGTH }) : undefined}
          hint={t('requisition.rejectCounter', { count: reason.trim().length })}
        />
      </div>
    </Dialog>
  );
};
